"use client";

import { mergeDateAndTime } from "@/utils/formChange";
import { FC, useEffect, useState } from "react";
import OrderFormCommon from "@/components/common/OrderForm";
import CommonCreate from "@/components/common/Create";
import { Tour } from "@/interface/entityInterface";
import axiosInstance from "@/utils/axiosInstance";
import { useUserContext } from "@/context/UserContext";
import { generateAvailableTimeSlots } from "@/utils/generateTimeSlots";

interface Props {
  data: Tour | null;
  title: string;
  description?: string;
}

const BookTour: FC<Props> = ({ data, title }) => {
  const { decodedToken } = useUserContext();
  const [loading] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [comissionPartnerId, setId] = useState(0);
  const [tourData, setTourData] = useState(data);

  const [formProp, setFormProp] = useState({
    fullName: "",
    client_phone: "",
    date: "",
    time: "",
    passengers: "",
    email: "",
    how_many_adults: "",
    how_many_children: "",
    additional_notes: "",
    tourId: 0,
  });

  const getCommissionPartner = async () => {
    try {
      const response = await axiosInstance.get(
        `/referral-agents/users/${decodedToken?.user.id}`,
      );
      setId(response.data.id);
    } catch (error) {
      console.error("Failed to fetch commission partner:", error);
    }
  };

  useEffect(() => {
    const unsub = async () => {
      if (decodedToken?.user.id) {
        await getCommissionPartner();
      }
    };

    unsub();
  }, [decodedToken?.user.id]);

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setFormProp({
      ...formProp,
      date: today,
      time: generateAvailableTimeSlots(new Date())[0],
      passengers: formProp.how_many_adults + formProp.how_many_children,
    });
  }, []);

  useEffect(() => {
    if (!formProp.tourId) return;
    const getTourData = async () => {
      const { data } = await axiosInstance.get<Tour>(
        `/tours/${formProp.tourId}`,
      );
      setTourData(data);
    };

    getTourData();
  }, [formProp.tourId]);

  return (
    <CommonCreate
      title={title}
      resource="taxi-orders/tms"
      data={{
        fixed_fee: true,
        pickup_time: mergeDateAndTime(formProp.date, formProp.time),
        fare: totalPrice,
        status: decodedToken?.permissions.user_role === "owner" ? "ACCEPTED" : "NEW_ORDER",
        pickup: "Tirana",
        dropoff: tourData?.name,
        pickup_latitude: 41.3275,
        pickup_longitude: 19.8187,
        dropoff_latitude: tourData?.dropoff_latitude,
        dropoff_longitude: tourData?.dropoff_longitude,
        client_name: formProp.fullName,
        client_phone: "" + formProp.client_phone,
        auto_assign: false,
        scheduled: false,
        adults: Number(formProp.how_many_adults),
        children: Number(formProp.how_many_children) || 0,
        passengers_number: Number(formProp.passengers),
        order_type: "tour",
        tour_id: tourData?.id,
        email: formProp.email,
        commission_partner_id: comissionPartnerId,
        notes: formProp.additional_notes,
        currency: "EUR",
      }}
      responseMessage="Tour booked"
    >
      <OrderFormCommon
        tourId={data?.id}
        formProp={formProp}
        setFormProp={setFormProp}
        finalPrice={totalPrice}
        setFinalPrice={setTotalPrice}
        loading={loading}
      />
    </CommonCreate>
  );
};

export default BookTour;
